<script lang="ts">
	import { attrValue } from '../utils/html';
	import Icon from '../elements/Icon.svelte';
	import type { ComponentSizes } from '../types/props';

	export let icon: string = null;
	export let iconSize: ComponentSizes = 'default';
	export let label: string = null;
	export let classNames: string = null;
</script>

<div class={attrValue(['w-full flex flex-col rounded-lg px-3 py-3', classNames])}>
	{#if icon || label || $$slots.header}
		<div class="flex font-semibold">
			{#if icon}
				<Icon name={icon} size={iconSize} classNames="mr-4 flex-shrink-0" />
			{/if}
			{#if label}
				<span class="first-letter:uppercase">{@html label}</span>
			{/if}
			{#if $$slots.header}
				<div class="md:flex-1">
					<slot name="header" />
				</div>
			{/if}
		</div>
	{/if}
	{#if $$slots.body}
		<div class="body mt-3 pt-3 border-t-2 border-current">
			<slot name="body" />
		</div>
	{/if}
</div>

<style lang="postcss">
	.body:empty {
		@apply hidden;
	}
</style>
